import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { Application } from '../../../../../application/application'
import { JAPAN_DX_ENABLE_ORIENTATION } from '../../../../../../experimentConstants'

/**
 * determineCurrentStepJapan
 *
 * @param application
 * @param options
 * @param fallback
 * - This allows orientation executes special logic to return the fallback value
 */
export function isOrientationStep(application: Application) {
  const hasScheduledOrientation = Boolean(application.dasherOrientation)

  const shouldEnableJapanDxOrientationStep = isFeatureFlagEnabled(
    JAPAN_DX_ENABLE_ORIENTATION
  )
  return shouldEnableJapanDxOrientationStep && !hasScheduledOrientation
}
